import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {RiskService} from '../../services/risk.service';
import {RoleService} from '../../../services/role.service';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {RiskAssementInquiry} from '../../../dto/risk-assement-inquiry';
import {toDateString} from '../../../providers/app-date-adapter';
import {FormControl} from '@angular/forms';
import {CustomerRisk} from '../../../dto/customer-risk';
import {Invoice} from '../../../dto/invoice';


@Component( {
  selector: 'app-risk-check',
  templateUrl: './risk-check.component.html',
  styleUrls: [ './risk-check.component.css' ],
} )
export class RiskCheckComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private changeDetectorRefs: ChangeDetectorRef,
    private riskService: RiskService,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;



  activeInquiries = 0;
  getActiveRiskInquiries() {
    if (!this.currentUserIsPartner()) {
      this.riskService.getActiveInquiries().subscribe(result => {
        this.activeInquiries = result;
      });
    }
  }

  ngOnInit() {
    this.getActiveRiskInquiries();
    this.table.filters.str = this.route.snapshot.queryParamMap.get( 'search' );
  }

  currentUserIsPartner(){
    return this.roleService.hasRoles('partner');
  }

  currentUserIsAdminOrCompliance(){

    if( this.roleService.hasRoles('admin') || this.roleService.hasRoles('compliance') ) {
return true;
}

    return false;

  }

  currentUserIsAdminOrManagerOrCompliance(){

    if( this.roleService.hasRoles('admin') || this.roleService.hasRoles('manager') || this.roleService.hasRoles('compliance') ) {
return true;
}

    return false;

  }

  getViewLink = (item: RiskAssementInquiry): string => '/risk/check/' + item.id.toString();


  dataSource = new MultiCrudDataSource( this.riskService );



    columns = [

      { columnDef: 'inquiryDate', header: 'Inquiry Date', cell: ( row: RiskAssementInquiry ) => `${ toDateString( row.inquiryDate ) || '' }` },
      { columnDef: 'title', header: 'Title', cell: (row: RiskAssementInquiry) => `${row.customer.title}` },
      { columnDef: 'firstName', header: 'First name', cell: (row: RiskAssementInquiry) => `${row.customer.firstName}` },
      { columnDef: 'lastName', header: 'Last name', cell: (row: RiskAssementInquiry) => `${row.customer.lastName}` },
      { columnDef: 'address', header: 'Address', cell: (row: RiskAssementInquiry) => `${row.customer.address}` },
      { columnDef: 'city', header: 'City', cell: (row: RiskAssementInquiry) => `${row.customer.city}` },
      { columnDef: 'zipCode', header: 'Zip code', cell: (row: RiskAssementInquiry) => `${row.customer.zipCode}` },
      { columnDef: 'email', header: 'Email', cell: (row: RiskAssementInquiry) => `${row.customer.email}` },
      { columnDef: 'phone', header: 'Mobile', cell: (row: RiskAssementInquiry) => `${row.customer.phone}` },
      { columnDef: 'dob', header: 'Date of birth', cell: (row: RiskAssementInquiry) => `${toDateString(row.customer.dob)}` },
      //{ columnDef: "cardsCount", header: "Cards", cell: ( row: CustomerRisk ) => `${ row.cards.length }` },
      { columnDef: 'risk', header: 'Risk Level', cell: ( row: RiskAssementInquiry ) => {

          let lvl = 0;

          if( row.customer.riskLevelOverride != null ){
            lvl = row.customer.riskLevelOverride;
          }else{
            lvl = row.customer.riskLevel;
          }

          if( lvl != null  ){

            if( lvl == 0 ){
              return 'low';
            }

            if( lvl == 1 ){
              return 'medium';
            }

            if( lvl == 2 ){
              return 'high';
            }

          }

        }},
      { columnDef: 'riskSumLoadSepaCount', header: 'Sepa count', cell: ( row: RiskAssementInquiry ) => `${ row.customer.riskSumLoadSepaCount || '' }` },
      { columnDef: 'riskSumLoadSepaCoun', header: 'Sepa sum', cell: ( row: RiskAssementInquiry ) => `${ row.customer.riskSumLoadSepa || '' }` },
      { columnDef: 'riskSumLoadSofortCount', header: 'Sofort count', cell: ( row: RiskAssementInquiry ) => `${ row.customer.riskSumLoadSofortCount || '' }` },
      { columnDef: 'riskSumLoadSofortCoun', header: 'Sofort sum', cell: ( row: RiskAssementInquiry ) => `${ row.customer.riskSumLoadSofort || '' }` },
      { columnDef: 'riskSumBankTransferLoadCount', header: 'BTL count', cell: ( row: RiskAssementInquiry ) => `${ row.customer.riskSumBankTransferLoadCount || '' }` },
      { columnDef: 'riskSumBankTransferLoad', header: 'BTL sum', cell: ( row: RiskAssementInquiry ) => `${ row.customer.riskSumBankTransferLoad || '' }` },
      { columnDef: 'riskSumLoadTotal', header: 'Total load sum', class: 'right', cell: ( row: RiskAssementInquiry ) => `${ row.customer.riskSumLoadTotal.formatThousands() }` }

  ];

  search( str: string ) {
    this.table.filters.str = str;
    this.onSearch();
  }

  onSearch( isInvalid = false ) {
    if ( !isInvalid ) {
      this.table.applyFilter();
    }
  }

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsAdmin(){
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return this.roleService.hasRoles('admin');
  }

  multiselectEnabled() {
    return this.roleService.hasRoles( 'admin');
  }

}
